import { isEmail } from "../../utils/global.utils";

export const managerValidation = ({
  firstName,
  lastName,
  email,
  contactNumber
}) => {
  const errors = {};
  if (!firstName) {
    errors.firstName = "* Required";
  }

  if (!lastName) {
    errors.lastName = "* Required";
  }

  if (!email) {
    errors.email = "* Required";
  } else if (!isEmail(email)) {
    errors.email = "Invalid email";
  }

  if (!contactNumber) {
    errors.contactNumber = "* Required";
  } else if (contactNumber.replace(/[\s-]/g, "").length < 10) {
    errors.contactNumber = "* Invalid format";
  }

  return errors;
};
